<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-video2-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-video2-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 1.20518338462303;"
    data-aspect-ratio="1.205"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-video2-xs-img"
      class="g-video2-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video2-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.136%;margin-top:-8.5px;left:91.7285%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle0">00:01</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:23.1837%;margin-top:-17.5px;left:72.8038%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle1">ICE agent 1 (shooter)</p>
      <p class="g-pstyle1">with phone in hand</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:28.881%;margin-top:-9.1px;left:37.9297%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-video2-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.86255613987195;"
    data-aspect-ratio="1.863"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-video2-sm-img"
      class="g-video2-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video2-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.136%;margin-top:-8.5px;left:82.0219%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle0">00:01</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:23.1837%;margin-top:-17.5px;left:69.7763%;margin-left:-73px;width:146px;"
    >
      <p class="g-pstyle1">ICE agent 1 (shooter)</p>
      <p class="g-pstyle1">with phone in hand</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:28.881%;margin-top:-9.1px;left:46.8187%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-video2-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 2.41036676924605;"
    data-aspect-ratio="2.41"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-video2-md-img"
      class="g-video2-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video2-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:7.1663%;margin-top:-9.6px;left:74.753%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">00:01</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:22.9219%;margin-top:-19.8px;left:65.3773%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle1">ICE agent 1 (shooter)</p>
      <p class="g-pstyle1">with phone in hand</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:28.5461%;margin-top:-10.2px;left:47.3858%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-video2-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 3.875;"
    data-aspect-ratio="3.875"
    data-min-width="930"
  >
    <div
      id="g-video2-lg-img"
      class="g-video2-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video2-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.5094%;margin-top:-9.6px;left:67.5667%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">00:01</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:24.9017%;margin-top:-19.8px;left:60.9667%;margin-left:-82px;width:164px;"
    >
      <p class="g-pstyle1">ICE agent 1 (shooter)</p>
      <p class="g-pstyle1">with phone in hand</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.3184%;margin-top:-10.2px;left:47.177%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 16:21 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 16:21 -->
<!-- ai file: video2.ai -->
<style lang="scss">
  #g-video2-box {
    container-type: inline-size;
    container-name: g-video2-box;
  }
  #g-video2-box,
  #g-video2-box .g-artboard {
    margin: 0 auto;
  }
  #g-video2-box p {
    margin: 0;
  }
  #g-video2-box .g-aiAbs {
    position: absolute;
  }
  #g-video2-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-video2-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-video2-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-video2-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-video2-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-video2-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-video2-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-video2-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-video2-lg {
        display: block !important;
      }
    }
  }
  #g-video2-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video2-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(16, 255, 251);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video2-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video2-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-video2-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video2-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(16, 255, 251);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video2-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video2-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-video2-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video2-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(16, 255, 251);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video2-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video2-md .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }
  #g-video2-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video2-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(16, 255, 251);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-video2-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-video2-lg .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
